import { useEffect, useState } from "react";
import NavItem from "./NavItem";
import { authService, getImageUrl } from "../../services";

const BottomBar = () => {
  const [token, setToken] = useState(null);
  const [avatarUrl, setAvatarUrl] = useState(null);

  useEffect(() => {
    const storedToken = localStorage.getItem("authToken"); // <- même clé que dans Login
    setToken(storedToken);

    if (storedToken) {
      const user = authService.getUser?.();
      setAvatarUrl(getImageUrl(user?.avatar));
    }
  }, []);

  return (
    <div className="fixed h-[60px] bottom-0 left-0 w-full bg-white border-t">
      <div className="flex justify-between items-center h-full px-3 max-w-[640px] m-auto">
        <NavItem icon="fi fi-rr-house-blank" iconSec="fi fi-sr-house-blank">
          Accueil
        </NavItem>
        <NavItem to="/money" icon="fi fi-rr-wallet" iconSec="fi fi-sr-wallet">
          Commissions
        </NavItem>
        <NavItem
          to={token ? "/account" : "/register"}
          icon="fi fi-rr-user"
          iconSec="fi fi-sr-user"
          avatarUrl={token ? avatarUrl : null}
        >
          Compte
        </NavItem>
      </div>
    </div>
  );
};

export default BottomBar;
